module.exports = __webpack_public_path__ + "media/img/themes/ticketforcity-sing-in-logo-13910746f3ab04638fcef8426dadf203.png";